<div class="row justify-content-md-center en-tête p-0 m-0">
  <h5 class="col-12 text-center pb-0 mb-0"> Mes Cours</h5>

  <div class="input-group col-9 p-1">
    <input type="text" id="inputCours" class="barreRecherche" (keyup)="rechercheCours()" placeholder="recherche.." title="Tapper ici un nom">
  </div>

  <div class="btn-group btn-group-toggle flex-wrap col-8 m-0 p-0" >
    <label class="btn btn-secondary ">
      <input type="radio" (click)="DateCours(1)" name="options" id="option1" autocomplete="off" > Passés
    </label>
    <label class="btn btn-secondary active">
      <input type="radio" (click)="DateCours(2)" name="options" id="option2" autocomplete="off" > Présents
    </label>
    <label class="btn btn-secondary">
      <input type="radio" (click)="DateCours(3)" name="options" id="option3" autocomplete="off" > Futurs
    </label>
  </div>

</div>

<!-- Partie inferieure avec le groupe item -->
<div class="row bodydashboard">
  <ul class="list-group col-12 pr-0 overflow-auto mt-0 pt-0 listeRecherche" style="max-height:70vh" id="ulCours" >
    <li class="list-group-item col-12  w-100 p-3 rounded-0" *ngFor="let item of tab, let i = index" class="list-group-item" >
       <a name="{{tab[i].semestre}}" id={{i}} href="#" data-toggle="modal" data-target="#CoursModal" (click)="setId($event)" >{{tab[i].nom}} {{tab[i].semestre}} {{tab[i].annee}} {{tab[i].prof}} </a>
    </li>
    
  </ul>
  <app-pop-up-info [info] = sendInfo(id) [modalName] = "name"></app-pop-up-info>

</div>

